<template>
  <div class="breadcrumbs clearfix">
    <div class="right breadcrumbs_item">
      <router-link :to="{name : 'home'}">דף הבית</router-link>
    </div>
    <div class="right breadcrumbs_step">/</div>

    <div class="right breadcrumbs_item" v-if="top && !sub">{{top.name}}</div>
    <div class="right breadcrumbs_item" v-if="top && sub">
      <a-div :href="top.link">{{top.name}}</a-div>
    </div>
    <div class="right breadcrumbs_step" v-if="sub && top">/</div>

    <div class="right breadcrumbs_item" v-if="sub">{{sub.name}}</div>
  </div>
</template>

<script>
  export default {
    props: ["top", "sub"],
    data() {
      return {
        home_url: wpData.home_url
      };
    }
  };
</script>

<style scoped>
</style>